module["exports"] = [
  "#{Name.last_name} #{suffix}",
  "#{Name.last_name} #{suffix}",
  "#{Name.man_last_name} a #{Name.man_last_name} #{suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/company/name.js
 ** module id = 955
 ** module chunks = 0
 **/